module.exports = __webpack_public_path__ + "img/ciphertext_pattern_2.44bffbfa.png";